const isLocalhost = (hostname) => hostname === "localhost" || hostname === "127.0.0.1";

const getDefaultApiEndpoint = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const { protocol, hostname, port, origin } = window.location;
  const isFrontendDevServer = ["3000", "4000", "4001"].includes(port);

  if (isFrontendDevServer) {
    return `${protocol}//${hostname}:8080`;
  }

  return origin;
};

export const normalizeApiEndpoint = (endpoint) => {
  const fallbackEndpoint = getDefaultApiEndpoint();

  if (!endpoint) {
    return fallbackEndpoint;
  }

  if (typeof window === "undefined") {
    return endpoint;
  }

  try {
    const url = new URL(endpoint);
    const currentHostname = window.location.hostname;

    if (isLocalhost(url.hostname) && !isLocalhost(currentHostname)) {
      url.hostname = currentHostname;
      return url.toString().replace(/\/$/, "");
    }
  } catch (error) {
    return endpoint;
  }

  return endpoint;
};

export const API_ENDPOINT = normalizeApiEndpoint(process.env.REACT_APP_API_ENDPOINT);
